let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6g1ru")).then(() => parcelRequire('UO0Gn'));